import { ApiQueryKey } from '@/configs/ApiQueryKey';
import { UUID } from '@/types/types';
import { Client } from '@/types/users';
import { Product } from './ProductApi';
import { fileTypeToHeader } from '@/utils/utilities';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum OrderStatus {
	PENDING = 'pending',
	PROCESSING = 'processing',
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
}

export enum OrderSearchParams {
	ORDER_ITEM = 'orderItem',
	COPY = 'copy',
}

export interface OrderItem extends BaseEntity {
	orderId: UUID;
	product: Product;
	price: number;
	totalPrice: number;
	quantity: number;
	deliveryDate: string;
	comment: string;
	totalNetPrice: number;
}

export interface ShippingDetails {
	shippingName: string;
	shippingStreet: string;
	shippingCity: string;
	shippingPostalCode: string;
	shippingPhoneNumber: string;
	shippingComment: string;
}

export interface CustomOrderItem {
	name: string;
	taxRate: number;
	netPrice: number;
}

export interface Order extends BaseEntity, ShippingDetails {
	client: Client;
	number: number;
	totalPrice: number;
	subtotal: number;
	offerDiscount: number;
	orderItems: OrderItem[];
	customOrderItems: CustomOrderItem[];
	status: OrderStatus;
	name: string;
	adminNote: string;
	offerId?: UUID;
}

class OrderApi extends EntityApi<Order> {
	constructor() {
		super(ApiQueryKey.orders);
		this.changeStatus = this.changeStatus.bind(this);
		this.generatePdf = this.generatePdf.bind(this);
		this.generateProductionPdf = this.generateProductionPdf.bind(this);
	}

	async changeStatus(data: { id: UUID; status: OrderStatus }) {
		const response = await httpClient.patch<Order>(
			`/${this.queryKey}/${data.id}/change-status`,
			{ status: data.status }
		);

		return response.data;
	}

	async generatePdf({ order }: { order: Order }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${order.id}/export/pdf`,
			{
				headers: {
					Accept: fileTypeToHeader('pdf'),
				},
				responseType: 'blob',
			}
		);

		return response.data;
	}

	async generateProductionPdf({ order }: { order: Order }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${order.id}/export-production`,
			{
				headers: {
					Accept: fileTypeToHeader('pdf'),
				},
				responseType: 'blob',
			}
		);

		return response.data;
	}
}
export default new OrderApi();
